import { render, staticRenderFns } from "./MessageCustomerModal.vue?vue&type=template&id=aa5eda0c"
import script from "./MessageCustomerModal.vue?vue&type=script&lang=ts"
export * from "./MessageCustomerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports